import { render, staticRenderFns } from "./detailsWarehouseEntryRecord.vue?vue&type=template&id=0639d212&scoped=true"
import script from "./detailsWarehouseEntryRecord.vue?vue&type=script&lang=js"
export * from "./detailsWarehouseEntryRecord.vue?vue&type=script&lang=js"
import style0 from "./detailsWarehouseEntryRecord.vue?vue&type=style&index=0&id=0639d212&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639d212",
  null
  
)

export default component.exports